import {CircularProgress, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";

interface Props {
    title?: string
    description?: string
    busy?: boolean
    action?: React.ReactNode
}

function PublicSurveyNotice({title, description, busy, action}: Props) {
    return (
        <Stack gap={2} alignItems={'center'} sx={{textAlign: 'center', py: {xs: 6, sm: 10}}}>
            {busy && <CircularProgress size={28}/>}

            {!!title && (
                <Typography variant={'h5'} component={'h1'}>
                    {title}
                </Typography>
            )}

            {!!description && (
                <Typography variant={'body1'} color={'text.secondary'} sx={{maxWidth: 440}}>
                    {description}
                </Typography>
            )}

            {action}
        </Stack>
    );
}

export default PublicSurveyNotice;
